class ReturnReasonCodeController extends AbstractEntityEditController
	@register()
	@inject 'returnReasonCode',
		'parseBool'
		'ReturnReasonCodeRepository'

	initialize: ->
		@mainCrud.entityType = 'return.reason.code'
		@mainCrud.entityTitle = 'return.reason.code.new'

		if @returnReasonCode.id?
			@mainCrud.entityTitle = @returnReasonCode.code
			@mainCrud.isNewEntity = false

		@returnReasonCode.is_neutral = @parseBool(@returnReasonCode.is_neutral)

	save: ->
		@mainCrud.saving = true
		@ReturnReasonCodeRepository
			.save(@returnReasonCode, @mainCrud.isNewEntity)
			.then (response) =>
				@afterSave(response, undefined, undefined, 'code')
			.catch (response) =>
				@handleErrors(response)

	delete: ->
		@deleteEntity(@ReturnReasonCodeRepository, @returnReasonCode)
